export default __webpack_public_path__ + "static/media/hero-img.baffd3f1.png";